import { render, staticRenderFns } from "./Quality.vue?vue&type=template&id=20b7257c&"
import script from "./Quality.vue?vue&type=script&setup=true&lang=js&"
export * from "./Quality.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports